<template>
  <div>
    <div class="row">
      <div class="col-md-10 offset-lg-1 mb-3 mt-3">
        <h4>{{ trans("streams.dashboard.learning_path") }}</h4>
        <p>{{ stream.description }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-lg-3 offset-lg-1">
        <progress-state
          v-if="stream.progress.unit.completed > 0 && stream.progress.hasOwnProperty('current')"
          :cardTitle="trans('courses.new_dashboard.what_next')"
          :buttonTitle="trans('courses.new_dashboard.start_now')"
          :subTitle="stream.progress.current.title"
          :iconLink="stream.progress.current.icon"
          @ctaClick="
            openElement(
              getMiuAle(stream.progress.current.aleId),
              stream.progress.current,
              stream.progress.current.completed ? 'review' : 'instructions'
            )
          "
        />
        <stream-progress :progress="stream.progress" :is-loading="isLoading" />
      </div>
      <div class="col-md-8 col-lg-7 pb-md-5">
        <div v-for="(ale, index) in stream.ales" :key="index">
          <h5 class="mb-3" v-if="ale.ale_type">{{ trans(aleTypeTitle(ale.ale_type.name)) }}</h5>
          <div class="mb-4" v-if="ale.groups.length > 0">
            <div v-for="(group, index) in ale.groups" :key="index">
              <div v-for="(element, index) in group.related" :key="index">
                <dashboard-card
                  :icon="setCardIcon(element)"
                  :completed="element.completed"
                  :type="cardElementType(element.miu_type, element.type)"
                  :title="element.title"
                  :description="element.short_description"
                  :options="element.softskills"
                  :is-locked="element.status !== 'open'"
                  :week-number="element.weekNumber"
                  :is-loading="currentElementId === Number(element.id) && isLoading"
                  @showToast="$bvToast.show('locked-chapter-toast')"
                  @onCta="openElement(ale, element, element.completed ? 'review' : 'instructions')"
                >
                  <component
                    :is="parseContent(element.type)"
                    :params="getParams(ale.id, element)"
                    :time-to-complete="element.time_to_complete"
                    :scheduled="element.scheduled"
                    :web-class-data="element"
                    @onCta="(status) => openElement(ale, element, status)"
                    @openDetails="openWebClassDetails"
                  />
                </dashboard-card>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="stream.progress.certificate"
          :class="stream.progress.certificate.unlocked ? 'unlocked' : 'locked'"
        >
          <dashboard-card
            :icon="stream.progress.certificate.icon"
            :title="stream.progress.certificate.name"
            :route="
              stream.progress.certificate.unlocked
                ? { name: 'stream-certificate', id: stream.id }
                : ''
            "
            :current="stream.progress.certificate.unlocked"
          >
            <b-button
              v-if="stream.progress.certificate.unlocked"
              variant="secondary"
              class="align-self-end"
              size="sm"
              :to="
                stream.progress.certificate.unlocked
                  ? { name: 'stream-certificate', id: stream.id }
                  : ''
              "
              >{{ trans("miu.certificate.overline") }}</b-button
            >

            <p v-if="!stream.progress.certificate.unlocked" class="w-100 pl-5 mb-0">
              {{ trans("streams.dashboard.complete_to_get_certificate") }}
            </p>
          </dashboard-card>
        </div>
      </div>
      <div class="col-12 pb-5" v-if="isMobile">
        <stream-progress :stream="stream" />
      </div>

      <b-toast
        id="locked-chapter-toast"
        :title="trans('streams.dashboard.blocked')"
        auto-hide-delay="2000"
        class="blocked-toast"
      >
        {{ trans("streams.dashboard.blocked_description") }}
      </b-toast>
    </div>
    <web-class-modal :web-class-data="currentWebClass" v-if="currentWebClass" />
  </div>
</template>

<script>
import UserProgress from "../molecules/UserProgress";
import DashboardCard from "../molecules/DashboardCard";
import ChaptersProgress from "../molecules/ChaptersProgress";
import ChaptersProgressList from "../molecules/ChaptersProgressList";
import WebClassModal from "./WebClassModal";
import MiuCardContent from "./stream-dashboard/MiuCardContent";
import MissionCardContent from "./stream-dashboard/MissionCardContent";
import WebClassCardContent from "./stream-dashboard/WebClassCardContent";
import StreamProgress from "./stream-dashboard/StreamProgress";
import ProgressState from "../molecules/ProgressState";
import { mapGetters, mapMutations } from "vuex";
import streamMixin from "../mixins/streamMixin";

export default {
  name: "StreamsDashboard",
  components: {
    WebClassCardContent,
    MissionCardContent,
    MiuCardContent,
    WebClassModal,
    UserProgress,
    DashboardCard,
    ChaptersProgress,
    ChaptersProgressList,
    StreamProgress,
    ProgressState,
  },
  props: {
    stream: Object,
    isLoading: Boolean,
  },
  data() {
    return {
      screenWidth: 0,
      currentWebClass: null,
    };
  },
  methods: {
    ...mapMutations({
      setCurrentAle: "streams/setCurrentAle",
    }),
    getParams(aleId, element) {
      return {
        id: this.stream.id,
        localisation: element.locale,
        aleId: aleId,
        elementId: element.id,
        timeToComplete: element.time_to_complete,
      };
    },
    parseContent(type) {
      switch (type.toLowerCase()) {
        case "mission": {
          return "mission-card-content";
        }
        case "webinar": {
          return "web-class-card-content";
        }
        default: {
          return "miu-card-content";
        }
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    openWebClassDetails(webClassData) {
      this.currentWebClass = webClassData;
      setTimeout(() => {
        this.$bvModal.show("web-class-modal");
      }, 200);
    },
    openElement(ale, element, status) {
      this.ifTypeOpenOrWebinar(element.status, element.type);

      this.setCurrentAle(ale);

      this.$router.push(
        this.itemRoute(this.$route.params.id, ale.id, element.locale, element, status)
      );
    },
    getMiuAle(aleId) {
      return this.stream.ales.find((ale) => ale.id === aleId);
    },
  },
  computed: {
    ...mapGetters({
      currentElementId: "streams/getCurrentElementId",
    }),

    isMobile() {
      return this.screenWidth > 768 ? false : true;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mixins: [streamMixin],
};
</script>

<style scoped lang="scss">
.complete-mission {
  white-space: nowrap;
}

.locked {
  opacity: 0.7;
  ::v-deep a {
    cursor: initial;
  }
}

.b-toast {
  top: 72px;
}
</style>
